import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-width": "2",
      d: "M12.75 6.75 7.5 12M7.5 12 5.25 9.75M12.75 6.75 7.5 12M7.5 12 5.25 9.75"
    }, null, -1)
  ]))]))
}
export default { render: render }